import _ from 'lodash';
import history from 'providers/history';
import React from 'react';
import FontAwesome from 'react-fontawesome';

import { NodeApi } from 'providers/api';
import { VintageGuitarArticle } from 'types/drupal/VintageGuitarArticleNode';

import BreadcrumbTrail from 'components/global/application/BreadcrumbTrail';
import EmbeddedContent from 'components/pages/default/EmbeddedContent';

import { Helmet } from 'react-helmet';

export interface OwnProps {
    location: Location;
}

type CombinedProps = OwnProps;

interface State {
    contentLoaded: boolean;
    content: VintageGuitarArticle;
}

class VintageGuitarsDetail extends React.Component<CombinedProps, State> {
    constructor(props: CombinedProps) {
        super(props);

        this.state = { content: null, contentLoaded: false };
    }

    public componentDidMount() {
        this.loadData();
    }

    public componentDidUpdate() {
        if (this.state.contentLoaded) {
            const targetAlias = this.targetAlias();
            if (targetAlias !== this.state.content.alias) {
                this.setState({ content: null, contentLoaded: false });
                this.loadData();
            }
        }
    }

    public stringToProperCase = (input: string) => {
        return input.toLowerCase().replace(/^(.)|\s(.)/g, $1 =>  $1.toUpperCase());
    }

    public breadcrumbTrail = () => {
        const breadCrumbTrail =  [
            {
                label: 'Home',
                route: '/'
            },
            {
                label: 'Vintage Guitar Magazine Articles',
                route: '/vintage-guitars'
            },
            {
                label: (this.state.content as VintageGuitarArticle).title,
                route: '/' + this.targetAlias()
            }
        ];
        return breadCrumbTrail;
    }

    public helmet() {
        const { content } = this.state;

        const title = (content as VintageGuitarArticle).meta_title;
        const description = (content as VintageGuitarArticle).meta_description;
        return (
            <Helmet>
                <meta name="title" content={title} />
                <meta name="description" content={description} />
                <title>{title}</title>
            </Helmet>
        );
    }

    public render() {
        const { content, contentLoaded } = this.state;

        if (!contentLoaded) return (<FontAwesome className="loading-spinner" name="spinner" size="3x" spin />);

        return(
            <div className="row DefaultPage-container">
                {this.helmet()}
                <div className="Results-breadcrumb offset-md-1 mb-3"><BreadcrumbTrail pathNodes={this.breadcrumbTrail()} /></div>
                <div className={'col-md-10 offset-md-1'} >
                    <h1>{(content as  VintageGuitarArticle).title}</h1>
                    <EmbeddedContent contentHtml={(content as  VintageGuitarArticle).body.value} />
                </div>
            </div>
        );
    }

    private targetAlias() {
        let targetAlias = this.props.location.pathname.slice(1);
        if (targetAlias.endsWith('/')) targetAlias = targetAlias.slice(0, -1);
        return targetAlias;
    }

    private loadData() {
        this.getNodeByAlias(this.targetAlias());
    }

    private getNodeByAlias(targetAlias: string) {
        NodeApi.getNode(targetAlias).then((content: VintageGuitarArticle) => {
            this.setState({ content, contentLoaded: true });
        }).catch(() => {
            history.push('/');
        });
    }
}

export default VintageGuitarsDetail;



// WEBPACK FOOTER //
// ./src/components/pages/vintageGuitars/VintageGuitarsDetail.tsx